import { select, Store } from '@ngrx/store';
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import { AppState } from '../../reducers';
import {
  selectWorkOSsInStore,
  selectWorkOSsPageLoading,
  selectWorkOSsShowInitWaitingMessage,
} from '../_selectors/workOS.selectors';

export class WorkOSsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectWorkOSsPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectWorkOSsShowInitWaitingMessage));

    this.store.pipe(select(selectWorkOSsInStore)).subscribe((response: QueryResultsModel) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
